import {
  Button,
  ListContainer,
  ListContext,
  PAGE_DEFAULT,
  PAGE_SIZE_UNLIMITED,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
  formatDate,
  pn,
} from "@compass/core";

import {
  Permission,
  PermissionAction,
  StudentPostHighSchoolListDto,
  StudentPostHighSchoolListFilter,
  TextingOptIn as TextingOptInModel,
} from "generated/openApi";
import { useList, useRouter } from "hooks";
import { studentTextingOptinPageRoute } from "pages/students/student-texting-optin/StudentTextingOptinPage";
import { useEffect, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { isAuthorized } from "services";
import ApiService from "services/apiService";

export const TextingOptIn = (props: { initialLoad: boolean; studentId: number }) => {
  const ROOT_PERMISSION: Permission = Permission.Texting;
  const navigate = useNavigate();
  const { matchTemplatePath } = useRouter();

  const [listFilter, setListFilter] = useState<StudentPostHighSchoolListFilter>({
    postHighSchoolFilter: { studentId: props.studentId },
    page: PAGE_DEFAULT,
    pageSize: PAGE_SIZE_UNLIMITED,
    sortObjects: [{ property: pn<TextingOptInModel>("id"), isDesc: false }],
  });
  const [listItems, setListItems] = useState<TextingOptInModel[]>([]);

  const { tableContainerRef, loadList } = useList({
    listFilter: listFilter,
    setListFilter: setListFilter,
    fetchList: (listFilter) => {
      ApiService.textingOptIn.getByStudentId(props.studentId).then((response) => {
        const arr = [response];
        setListItems(arr);
      });
    },
  });

  useEffect(() => {
    if (props.initialLoad) {
      loadList(listFilter);
    }
  }, [props.initialLoad]);

  return (
    <>
      <ListContainer
        fullHeight
        header={
          <Stack direction="row" justifyContent="space-between" alignItems="center">
            <Typography variant="inherit">Texting Opt-In</Typography>

            <Stack direction="row" alignItems="center" spacing="sm">
              {(isAuthorized(ROOT_PERMISSION, PermissionAction.Create) && listItems.filter(x => x.id == 0).length == 1) && (
                <Button
                  variant="text"
                  onClick={() =>
                    navigate({
                      pathname: studentTextingOptinPageRoute.getPath({
                        id: 0,
                        studentId: props.studentId,
                        crudMode: "edit",
                        screenType: "dialog",
                      }),
                    })
                  }
                  sx={{ minWidth: "auto" }}
                >
                  + New
                </Button>
              )}
            </Stack>
          </Stack>
        }
        tableContainer={
          <TableContainer ref={tableContainerRef}>
            <Table stickyHeader>
              <TableBody>
                {listItems.filter(x => x.id != 0).map((listItem) => (
                  <TableRow
                    key={listItem.id}
                    onClick={() =>
                      navigate({
                        pathname: studentTextingOptinPageRoute.getPath({
                          id: listItem.id,
                          studentId: props.studentId,
                          crudMode: "view",
                          screenType: "dialog",
                        }),
                      })
                    }
                  >
                    <TableCell>{listItem.optInMethod?.name}</TableCell>
                    <TableCell>{formatDate(listItem.optInDate)}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        }
      />

      <ListContext.Provider value={{ loadList: (options) => loadList(listFilter, { resetPage: options?.resetPage }) }}>
        {matchTemplatePath(studentTextingOptinPageRoute.templatePath) && <Outlet />}
      </ListContext.Provider>
    </>
  );
};
